import React from "react";
import DateTimeTask from "../../../job/task/status/datetime";

const render = (deadlineAt, record) => <DateTimeTask value={deadlineAt} status={record.status} />;

export default render;
